import { useState } from 'react';
import { FaChevronDown } from 'react-icons/fa';
import { FAQS } from '../data/content';
import './FAQ.css';

export default function FAQ() {
  const [open, setOpen] = useState(0);

  return (
    <section className="dh-faq" id="faq">
      <div className="dh-container dh-faq__grid">
        <h2>FAQs</h2>
        <div className="dh-faq__list">
          {FAQS.map((item, index) => {
            const isOpen = open === index;
            return (
              <div className={`dh-faq__item ${isOpen ? 'is-open' : ''}`} key={item.q}>
                <button
                  type="button"
                  className="dh-faq__q"
                  aria-expanded={isOpen}
                  onClick={() => setOpen(isOpen ? -1 : index)}
                >
                  <span>{item.q}</span>
                  <FaChevronDown aria-hidden />
                </button>
                {isOpen && <p className="dh-faq__a">{item.a}</p>}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
